<template>
  <!-- 培训班报名表 -->
  <div class="container">
    <div class="operation-condition">
      <div>
        <el-input
          placeholder="请输入姓名、培训班名称、手机号码、单位"
          v-model.trim="searchInfo"
          style="min-width: 360px"
        >
          <el-button type="primary" slot="append" @click="searchHandler"
            >搜索</el-button
          >
        </el-input>
      </div>
      <div style="float: right">
        <el-button type="danger" v-on:click="exportTrainForm" v-if="isManage"
          >导出报名表</el-button
        >
      </div>
    </div>
    <div class="table_div">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6' }"
      >
        <!-- <el-table-column align="center"  width="55"/> -->
        <el-table-column type="index" label="序号" align="center" width="60">
        </el-table-column>
        <el-table-column
          prop="id"
          label="报名表ID"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="title" label="培训班名称" align="center" />

        <el-table-column prop="name" label="姓名" align="center" width="100">
        </el-table-column>
        <el-table-column
          prop="landlineNumber"
          label="联系方式"
          align="center"
          width="160"
        >
          <template slot-scope="scope">
            {{scope.row.phonenumber? scope.row.phonenumber + "&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;" +scope.row.landlineNumber : scope.row.landlineNumber}}
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位" align="center" width="120">
        </el-table-column>

        <el-table-column
          prop="invoiceType"
          width="120"
          align="center"
          label="开票方式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.invoiceType == '1'" type="success">个人</span>
            <span v-if="scope.row.invoiceType == '2'" type="info">单位</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="status"
          width="120"
          align="center"
          label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status=='0'" type="success">发布中</el-tag>
            <el-tag v-if="scope.row.status=='1'" type="info">未发布</el-tag>
          </template>
        </el-table-column> -->

        <el-table-column prop="createTime" label="日期" align="center"   :formatter="formatter">
        </el-table-column>

        <el-table-column
          prop="operate"
          width="200"
          align="center"
          v-if="isManage"
          :key="Math.random()"
          label="操作"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="预览"
              placement="bottom"
            >
              <i class="el-icon-view" @click="handleClickView(scope.row)"></i>
            </el-tooltip>
            <i class="el-icon-edit" @click="handleEditClick(scope.row)"></i>
            <i class="el-icon-delete" @click="handleDeleteClick(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.page_num"
          :page-size="pagenation.page_size"
          background
          layout="total, prev, pager, next"
          :total="pagenation.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DictionaryTrainApi from '@/api/dictionaryTrain'
import { mapRequestActions } from '@/utils'
import { checkRole } from '../../utils/auth'
import { MessageBox } from 'element-ui'
import { getMyDate } from '@/utils/timeUtils.js'
export default {
  data () {
    return {
      loading: false,
      selectModuleValue: '',
      isManage: false, // 是否是管理用户
      title: this.$route.query.title, // 获取从辞书培训班列表传递的title
      optionStatus: '',
      searchInfo: '',
      options: [],
      activityList: [
        // 活动列表
        { id: '', label: '全部' },
        { id: 1, label: '姓名' },
        { id: 2, label: '单位' },
        { id: 3, label: '培训班ID' },
        { id: 4, label: '培训班名称' }
      ],
      selectArr: [],
      delDisable: true,
      tableData: [],
      pagenation: {
        page_num: 1,
        page_size: 10,
        total: 0
      }
    }
  },
  created () {
    this.searchInfo = this.title ? this.title : ''
    this.handleTrainRegistActivityList()
    this.isManage = checkRole(['manage'])
  },
  methods: {
    ...mapRequestActions(DictionaryTrainApi),

    /**
     * 获取学会活动列表
     */
    handleTrainRegistActivityList () {
      this.getTrainRegistListAction({
        searchValue: this.searchInfo,
        pageNum: this.pagenation.page_num,
        pageSize: this.pagenation.page_size
      }).then((res) => {
        if (res.status) {
          this.pagenation = Object.assign({}, this.pagenation, {
            currentPage: 1,
            total: res.result.total
          })
          this.tableData = res.result.rows || []
        }
      })
    },

    /**
     * 分页
     */
    handleCurrentChange (newPage) {
      this.pagenation = Object.assign({}, this.pagenation, { newPage })
      this.handleTrainRegistActivityList()
    },
    /**
     * 预览
     */
    handleClickView (item) {
      this.$router.push({
        path: '/dictionary-train-apply-edit',
        query: { id: item.id, isView: true }
      })
    },

    /**
     * 编辑
     */
    handleEditClick (item) {
      this.$router.push({
        // path: '/dictionary-train'
        path: '/dictionary-train-apply-edit',
        query: { id: item.id }
      })
    },

    searchHandler () {
      this.handleTrainRegistActivityList()
    },

    // selected items change
    handleSelectionChange (arr) {
      this.selectArr = arr
      if (arr.length !== 0) {
        this.delDisable = false
      } else {
        this.delDisable = true
      }
    },
    formatter (row, column, cellValue) {
      if (row) { return getMyDate(row.createTime) }
    },

    /**
     * 导出报名表
     */
    async exportTrainForm () {
      // const result = await this.exportTrainInfoAction({ searchValue: this.searchValue })
      const result = await this.exportTrainInfoAction({
        searchValue: this.searchInfo
      })
      if (result.status) {
        // console.log('result.result', result.result)
        DictionaryTrainApi.downLoadData({
          fileName: result.result.msg,
          delete: true
        }).then((resp) => {
          const blob = new Blob([resp])
          const fileName = '培训班报名表.xlsx'
          if ('download' in document.createElement('a')) {
            // 非IE下载
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            const url = window.URL || window.webkitURL || window.moxURL
            elink.href = url.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            url.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else {
            navigator.msSaveBlob(blob, fileName)
          }
        })
      }
      // }

      // if (resultData.status) {
      //   console.log('resultData', resultData)
      // }
      // exportExcel(
      //   '/function/trainRegist/export',
      //   {
      //     responseType: 'blob',
      //     method: 'get'
      //   },
      //   '导出报名表.xls'
      // )
    },

    /**
     * 删除 单选操作
     */
    handleDeleteClick (item) {
      const _this = this
      MessageBox.confirm('此操作将永久删除该报名表, 是否继续?', '提示').then(
        () => {
          const longIds = [item.id]
          this.deleteTrainRegistAction({ longIds }).then((res) => {
            if (res.status) {
              _this.$message.success('删除成功')
              _this.handleTrainRegistActivityList()
            } else {
              _this.$message.error(res.errorMsg || '删除失败')
            }
          })
        }
      )
    }
  }
}
</script>

<style lang='less' scoped>
@import "./index.less";
</style>
